import { create } from 'zustand';

interface HelperStartDialogState {
  open: boolean;
  startupPromptShown: boolean;
  show: () => void;
  close: () => void;
  showStartupPromptOnce: () => void;
}

export const useHelperStartDialogStore = create<HelperStartDialogState>((set, get) => ({
  open: false,
  startupPromptShown: false,
  show: () => set({ open: true }),
  close: () => set({ open: false }),
  showStartupPromptOnce: () => {
    if (get().startupPromptShown) {
      return;
    }
    set({ startupPromptShown: true, open: true });
  },
}));
